<template>
	<div class="container body fix-footer">
        <div class="row justify-content-center">
            <div class="col-md-8 mt-5 mb-3">
                <div class="card">
                    <div class="card-header"><h3>{{$t('pages.VerifyEmailForm')}}</h3></div>
                    <div class="card-body">
                        <div class="alert alert-danger" v-if="error" v-html="$t(error)">
                        </div>
                        <form @submit.prevent="submit">
                            <formly-form :form="form" :model="model" :fields="fields" ref="verifyEmailForm"/>
                            <button type="submit" :disabled="disabled" class="btn btn-primary">{{ $t('button.Continue') }}</button>
                        </form>
                        <vue-recaptcha :sitekey="siteKey"
                                       @expired="onExpired"
                                       @verify="onVerify"
                                       ref="recaptcha"
                                       size="invisible">

                        </vue-recaptcha>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import isEmail from 'validator/lib/isEmail';
  	import isLength from 'validator/lib/isLength';
  	import { mapActions } from 'vuex';
  	import api from '../../api';
  	import { ERROR_MESSAGES, SITE_KEY_RECAPTCHA, ROUTER_NAMES } from '../../constants';
  	import VueRecaptcha from 'vue-recaptcha';


	export default {
	    name: 'VerifyEmailForm',
	    components: { VueRecaptcha },
	    data() {
	      return {
	        error: '',
	        disabled: false,
	        form: {},
	        siteKey: SITE_KEY_RECAPTCHA,
	        model: {
	          email: '',
	        },
	        fields: [
	          {
	            key: 'email',
	            type: 'input',
	            templateOptions: {
	              label: this.$t('fields.Email')
	            },
	            required: true,
	            validators: {
	              validEmail: {
	                expression(field, model, next) {
	                  next(isEmail(model[field.key]));
	                },
	                message: 'Email nemá platný tvar'
	              }
	            }
	          },
	        ]
	      };
	    },
	    methods: {
	      onVerify(recaptcha) {
	      	api.auth.sendVerificationEmail({
	      		email: this.model.email,
	      		recaptcha: recaptcha
	      	}).then(() => {
	      		this.disabled = false;
	      		this.$router.push({ 
	      			name: ROUTER_NAMES.VERIFY_EMAIL_SUCCESS
	      		});
	      	}, (e) => {
	      		this.disabled = false;
	      		this.$refs.recaptcha.reset();
            	if (e.response.data && e.response.data.message) {
              		this.error = 'errorMessages.' +  e.response.data.message;
            	} else {
              		this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
            	}
	      	})
	      },
	      onExpired() {
	        this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
	      },	
	      submit() {
	        this.error = null;
	        this.$refs.verifyEmailForm.validate()
	          .then(() => {
	            if (!this.form.$valid) return;
	            this.disabled = true;
	            this.$refs.recaptcha.execute()
	          })
	          .catch((e) => {

	          });
	      },
	    }
	}
</script>